import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import { createElementVNode as _$ce, createUnknownComponentVNode as _$cc, className as _$cn, superCall as _$su, extend as _$ex, EMPTY_OBJ as _$em, createTextVNode as _$ct } from 'intact-vue-next';
import { linkEvent } from 'intact-vue-next';
import { DropdownMenu } from '../dropdown';
import { DatepickerCalendar } from './calendar';
import { DatepickerTime } from './time';
import { Icon } from '../icon';
import { Button } from '../button';
import { _$ } from '../../i18n';
import { makePanelStyles } from './styles';
import { PanelTypes, PanelFlags } from './usePanel';
import { isFunction } from 'intact-shared';
import { Tabs, Tab } from '../tabs';
export default function ($props, $blocks, $__proto__) {
  var _classNameObj,
    _this = this;
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var _this$get = this.get(),
    className = _this$get.className,
    type = _this$get.type,
    range = _this$get.range,
    multiple = _this$get.multiple,
    shortcuts = _this$get.shortcuts;
  var _this$value = this.value,
    value = _this$value.value.value,
    onChangeDate = _this$value.onChangeDate,
    onConfirm = _this$value.onConfirm,
    onChangeTime = _this$value.onChangeTime,
    onChangeDateForRange = _this$value.onChangeDateForRange,
    getTimeValue = _this$value.getTimeValue;
  var k = this.config.k;
  var classNameObj = (_classNameObj = {}, _classNameObj[k + "-datepicker-content"] = true, _classNameObj[className] = className, _classNameObj[makePanelStyles(k)] = true, _classNameObj);
  var _this$disabled = this.disabled,
    isDisabledTime = _this$disabled.isDisabledTime,
    isDisabledConfirm = _this$disabled.isDisabledConfirm;
  var _this$panel = this.panel,
    startPanel = _this$panel.startPanel,
    endPanel = _this$panel.endPanel,
    getPanel = _this$panel.getPanel,
    startRef = _this$panel.startRef,
    endRef = _this$panel.endRef;
  var generatePanel = function generatePanel(flag) {
    var panel = getPanel(flag);
    var timeValue = getTimeValue(flag);
    return _$ce(2, 'div', [function () {
      if (type === 'datetime') {
        var dateString = '0000-00-00';
        var timeString = '00:00:00';
        if (timeValue) {
          var valueString = _this.formats.getShowString(timeValue).split(/\s+/);
          dateString = valueString[0];
          timeString = valueString[1];
        }
        return _$cc(Tabs, {
          'type': 'card',
          'value': panel.value,
          'ev-$change:value': panel.set,
          'children': [_$cc(Tab, {
            'value': PanelTypes.Date,
            'children': dateString
          }), _$cc(Tab, {
            'value': PanelTypes.Time,
            'disabled': !timeValue,
            'children': timeString
          })]
        });
      }
    }(), panel.value === PanelTypes.Date ? _$cc(DatepickerCalendar, {
      'value': value,
      'ev-change': onChangeDate,
      'type': type === 'datetime' ? 'date' : type,
      'flag': flag,
      'ref': flag === PanelFlags.Start ? startRef : endRef
    }, null, flag === PanelFlags.Start ? startRef : endRef) : _$cc(DatepickerTime, {
      'value': timeValue,
      'ev-$change:value': function ev$changeValue(v) {
        return onChangeTime(v, flag);
      },
      'format': _this.formats.getValueFormat(),
      'flag': flag,
      'isDisabledTime': isDisabledTime
    })], 0, _$cn(k + "-datepicker-calendar-wrapper"));
  };
  return _$su.call($this, {
    'className': _$cn(k + "-datepicker")
  }, function ($blocks) {
    var _$blocks = {},
      __$blocks = _$ex({}, $blocks);
    return (_$blocks['base-menu'] = function ($super) {
      var _this2 = this;
      return _$cc(DropdownMenu, {
        'className': _$cn(classNameObj),
        'children': [shortcuts && shortcuts.length ? _$ce(2, 'div', _mapInstanceProperty(shortcuts).call(shortcuts, function ($value) {
          var label = isFunction($value.label) ? $value.label() : $value.label;
          return _$ce(2, 'div', label, 0, _$cn(k + "-datepicker-shortcut c-ellipsis"), {
            'title': label,
            'ev-click': linkEvent($value, _this2.setByShortcut)
          });
        }), 0, _$cn(k + "-datepicker-shortcuts")) : undefined, _$ce(2, 'div', [_$ce(2, 'div', [generatePanel(PanelFlags.Start), _$ct('\n                    '), range ? generatePanel(PanelFlags.End) : null], 0, _$cn(k + "-datepicker-calendars")), type === 'datetime' ? _$ce(2, 'div', _$cc(Button, {
          'type': 'primary',
          'size': 'small',
          'disabled': isDisabledConfirm(),
          'ev-click': onConfirm,
          'children': _$('确定')
        }), 2, _$cn(k + "-datepicker-footer")) : undefined], 0, _$cn(k + "-datepicker-wrapper"))]
      });
    }, __$blocks['base-menu'] = function ($super, data) {
      var block = $blocks['base-menu'];
      var callBlock = function callBlock() {
        return _$blocks['base-menu'].call($this, $super, data);
      };
      return block ? block.call($this, callBlock, data) : callBlock();
    }), (_$blocks['suffix'] = function ($super) {
      return _$cc(Icon, {
        'className': _$cn(k + "-icon-calendar")
      });
    }, __$blocks['suffix'] = function ($super, data) {
      var block = $blocks['suffix'];
      var callBlock = function callBlock() {
        return _$blocks['suffix'].call($this, $super, data);
      };
      return block ? block.call($this, callBlock, data) : callBlock();
    }), __$blocks;
  }.call($this, $blocks), $__proto__);
}
;